import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from "react-bootstrap";
import VoiceRelationsIcons from 'components/LM/common/VoiceRelationsIcons';

function VoiceProfileBadge(props) {
	const { type, name, isRestricted, isActive = true } = props;
	let badgeColor = isRestricted ? "warning" : "info";
	if (!isActive) {
		badgeColor = "danger";
	}
	return (
		<Badge pill bg={badgeColor}>
			<VoiceRelationsIcons type={type} size="18" color="#fff" />
			{name}
		</Badge>
	)
}

VoiceProfileBadge.propTypes = {
	type: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
}

export default VoiceProfileBadge;
